import { render, staticRenderFns } from "./MandatesTable.vue?vue&type=template&id=32ad9a2e&scoped=true"
import script from "./MandatesTable.vue?vue&type=script&lang=js"
export * from "./MandatesTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=32ad9a2e&prod&scoped=true&lang=css&external"
import style1 from "./MandatesTable.vue?vue&type=style&index=1&id=32ad9a2e&prod&scoped=true&lang=css"
import style2 from "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=32ad9a2e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad9a2e",
  null
  
)

export default component.exports